(function () {
  function getTextContent(el) {
    if (!el) return "";
    return (el.textContent || "").replace(/\s+/g, " ").trim();
  }

  function cleanDropdown(details) {
    var panel = details.querySelector(":scope > .sqarp-option-details-drop");
    if (!panel) return;

    var options = panel.querySelectorAll(":scope > a.sqarp-option, :scope > span.sqarp-option");

    options.forEach(function (option) {
      var text = getTextContent(option);

      if (!text) {
        option.style.display = "none";
        return;
      }

      option.style.display = "";
    });
  }

  function closeAllExcept(current) {
    document.querySelectorAll(".sqarp-option-details[open]").forEach(function (details) {
      if (details !== current) {
        details.removeAttribute("open");
      }
    });
  }

  function initDropdown(details) {
    if (!details || details.dataset.sqarpDropdownInit === "true") return;

    var summary = details.querySelector(":scope > summary");
    var panel = details.querySelector(":scope > .sqarp-option-details-drop");

    if (!summary || !panel) return;

    details.dataset.sqarpDropdownInit = "true";

    cleanDropdown(details);

    summary.addEventListener("click", function () {
      setTimeout(function () {
        if (details.hasAttribute("open")) {
          closeAllExcept(details);
        }
      }, 0);
    });

    panel.querySelectorAll("a.sqarp-option").forEach(function (link) {
      link.addEventListener("click", function () {
        details.removeAttribute("open");
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll(".sqarp-option-details").forEach(initDropdown);
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".sqarp-option-details")) return;

    document.querySelectorAll(".sqarp-option-details[open]").forEach(function (details) {
      details.removeAttribute("open");
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (node.matches && node.matches(".sqarp-option-details")) {
          initDropdown(node);
        } else if (node.querySelectorAll) {
          initAll(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.initSqarpDropdownFix = initAll;
})();